const config = {
    homePage: {
        meta: {
            en: {
                title: "Ciprobet - Betting - Live Betting - Casino - Poker",
                description: "Enjoy high-odds sports betting with Ciprobet. Earn cash rewards on every coupon you play. No limits.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "Ciprobet - Bahis - Canlı Bahis - Casino - Poker",
                description: "Ciprobet Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. Ciprobet ile oynadığın her kupona nakit para kazan. Limit yok.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis, siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    signUpPage: {
        meta: {
            en: {
                title: "Ciprobet - Betting - Live Betting - Casino - Poker",
                description: "Enjoy high-odds sports betting with Ciprobet. Earn cash rewards on every coupon you play. No limits.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "Ciprobet - Bahis - Canlı Bahis - Casino - Poker",
                description: "Ciprobet Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. Ciprobet ile oynadığın her kupona nakit para kazan. Limit yok.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis, siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    livePage: {
        meta: {
            en: {
                title: "Live Betting - Best Live Betting Site Ciprobet",
                description: "Join Ciprobet, the best betting site with the widest live betting variety, the highest live betting odds, and the most live matches, and win!",
                keywords: "live betting, live betting site, best live betting, most trusted live betting",
            },
            tr: {
                title: "Canlı Bahis - En İyi Canlı Bahis Sitesi Ciprobet",
                description: "Canlı bahis alanında en çok canlı bahis çeşiti, en yüksek canlı bahis oranlar ve en çok canlı bahis karşılaşma ile en iyi bahis sitesi olan Ciprobet’ya gelin, kazanın!",
                keywords: "canlı bahis, canlı bahis sitesi, en iyi canlı bahis, en güvenilir canlı bahis",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    sportPage: {
        meta: {
            en: {
                title: "Sports Betting - Best Betting Site Ciprobet",
                description: "Join Ciprobet, the best betting site with the widest sports betting variety, the highest odds, and the most matches, and win!",
                keywords: "sports betting, sports bets, sports betting site, sports betting sites",
            },
            tr: {
                title: "Spor Bahisleri - En İyi Bahis Sitesi Ciprobet",
                description: "Spor bahisleri alanında en çok bahis çeşiti, en yüksek bahis oranları ve en çok karşılaşma ile en iyi bahis sitesi olan Ciprobet’ya gelin, kazanın!",
                keywords: "spor bahis, spor bahisleri, spor bahis sitesi, spor bahisleri sitesi",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    casinosPage: {
        meta: {
            en: {
                title: "Live Casino",
                description: "Play popular casino games like roulette, blackjack, baccarat, and casino hold'em with live streams in the Ciprobet live casino lobby!",
                keywords: "live casino, live roulette, live blackjack, live baccarat, live turkish roulette, live holdem",
            },
            tr: {
                title: "Canlı Casino",
                description: "Rulet, blackjack, baccarat, casino hold’em gibi popüler casino oyunlarını canlı yayın aktarımları ile Ciprobet’in canlı casino salonunda oynayın!",
                keywords: "canlı casino, canlı rulet, canlı blackjeack, canlı baccarat, canlı türk ruleti, canlı holdem",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsPage: {
        meta: {
            en: {
                title: "Slot Games - Best Casino Site Ciprobet",
                description: "Join Ciprobet, the best casino site with the widest slot game variety, and win on live casino slots!",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "Slot Oyunları - En İyi Casino Sitesi Ciprobet",
                description: "Slot oyunları alanında en çok slot oyun çeşiti ile en iyi casino sitesi olan Ciprobet’ya gelin, canlı casino’daki slot oyunlarında kazanın!",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsBattlePage: {
        meta: {
            en: {
                title: "Slot Battle",
                description: "Slot Battle, first in Turkey",
                keywords: "",
            },
            tr: {
                title: "Slot Battle",
                description: "Slot Battle Türkiye'de ilk",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveCasinoPage: {
        meta: {
            en: {
                title: "Live Slot",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Canlı Slot",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    forgotPassword: {
        meta: {
            en: {
                title: "Forgot Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifremi unuttum",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    resetPassword: {
        meta: {
            en: {
                title: "Reset Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre yenileme",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    changePassword: {
        meta: {
            en: {
                title: "Change Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre Değiştir",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    promoPage: {
        meta: {
            en: {
                title: "Bonuses - Casino Bonuses - Betting Bonuses - Ciprobet",
                description: "Win with Ciprobet, the betting site with the highest bonus rates and the lowest wagering requirements!",
                keywords: "bonus, betting bonuses, casino bonuses, bonus sites",
            },
            tr: {
                title: "Bonuslar - Casino Bonusları - Bahis Bonusları - Ciprobet",
                description: "En yüksek oranlı bonuslar ve en düşük çevrim şartına sahip bonus veren bahis sitesi olan Ciprobet ile kazanın!",
                keywords: "bonus, bahis bonusları, casno bonusları, bonus veren siteler",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    aboutUsPage: {
        meta: {
            en: {
                title: "About Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hakkımızda",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    myAccountPage: {
        meta: {
            en: {
                title: "My Account",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hesabım",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    betOnGames: {
        meta: {
            en: {
                title: "BetOnGames Live Casino Games - Best Casino Site Ciprobet",
                description:
                    "Join Ciprobet, the best casino site with the widest BetOnGames live casino and casino variety, and win on live casino slots!",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "BetOnGames Canlı Casino Oyunları - En İyi Casino Sitesi Ciprobet",
                description:
                    "BetOnGames oyunları ile canlı casino ve casino alanında en çok casino oyun çeşiti ile en iyi casino sitesi olan Ciprobet'ya gelin, canlı casino'daki slot oyunlarında kazanın!",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    twain: {
        meta: {
            en: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            tr: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveGames: {
        meta: {
            en: {
                title: "Bingo - Best Casino Site Ciprobet",
                description: "Join Ciprobet, the best bingo site with the widest live bingo variety, and win at bingo!",
                keywords: "bingo, live bingo, bingo games, play bingo",
            },
            tr: {
                title: "Tombala - En İyi Casino Sitesi Ciprobet",
                description: "Canlı tombala alanında en çok tombala oyun çeşiti ile en iyi tombala sitesi olan Ciprobet'ya gelin, tombala oyunlarında kazanın!",
                keywords: "tombala, canlı tombala, tombala oyunları, tombala oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lottery: {
        meta: {
            en: {
                title: "Lottery",
                description: "Play lottery",
                keywords: "lottery, play lottery",
            },
            tr: {
                title: "Loto",
                description: "Loto oyna",
                keywords: "loto, loto oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    tvbet: {
        meta: {
            en: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            tr: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    helpPage: {
        meta: {
            en: {
                title: "Contact Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Bize Ulaşın",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    mailVerify: {
        meta: {
            en: {
                title: "Email Verification",
                description: "",
                keywords: "",
            },
            tr: {
                title: "E-Posta doğrulama",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lobbyPage: {
        meta: {
            en: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
};

export default config;
